export default {
    bgColor: 0x64ddf9,
    primaryKey: "BGElmnts_Cld1",
    secondaryKey: "BGElmnts_Cld2",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setScale(data.scaleX, data.scaleY);
        image.alpha = 0;
        image.setPosition(data.x - 200, data.y);
        let deltaX = 1-(data.x/bg.scene.size.width);

        bg.scene.addTween(image, 2000, {x: data.x, easeParams: [1,1], delay: 500 * deltaX}, "Elastic");
        bg.scene.addTween(image, 600, {alpha: 1, delay: 500 * deltaX}, Phaser.Math.Easing.Sine.Out);
    },
    animateOut: (image, bg)=>{
        let deltaX = (image.x/bg.scene.size.width);
        bg.scene.addTween(image, 800, {alpha: 0, x: image.x + 200}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Cld1",
            x: 182.74021584517612, y: 154.79732739420936,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 852.3912356940584, y: 670.5033407572383,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cld1",
            x: 181.88497827193362, y: 634.5701559020044,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 853.956948413786, y: 188.42761692650333,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cld1",
            x: 1012.7682861579821, y: 495.8641425389755,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 1056.926385572042, y: 356.184855233853,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld2",
            x: 278.67158647509433, y: 480.0623608017817,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Cld2",
            x: 746.2103511725327, y: 500.29844097995544,
            angle: 0,
            scaleX: -0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 779.1436662360204, y: 347.64587973273944,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Cld2",
            x: 504.16478095760095, y: 596.8084632516704,
            angle: 0,
            scaleX: 1.05,
            scaleY: 1.05
        },{
            key: "BGElmnts_Cld1",
            x: 522.8085711675736, y: 421.77505567928733,
            angle: 0,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Cld2",
            x: 503.30954338435845, y: 114.44320712694878,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Cld1",
            x: 304.0658627934594, y: 778.4610244988864,
            angle: 0,
            scaleX: 0.4499999999999996,
            scaleY: 0.4499999999999996
        },{
            key: "BGElmnts_Cld2",
            x: 521.9933445562385, y: 276.3719376391982,
            angle: 0,
            scaleX: -0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Cld2",
            x: 279.38206162157934, y: -2.461024498886413,
            angle: 0,
            scaleX: -0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 303.61823852588446, y: 299.4632516703786,
            angle: 0,
            scaleX: 0.4999999999999996,
            scaleY: 0.4999999999999996
        },{
            key: "BGElmnts_Cld2",
            x: 745.9208263190177, y: 17.801781737193764,
            angle: 0,
            scaleX: -0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 993.6768716804344, y: 24.22271714922049,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Cld1",
            x: 46.309817432042706, y: 356.6325167037862,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnts_Cld1",
            x: 9.126988476947371, y: 497.1804008908686,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnts_Cld2",
            x: 522.2828694097535, y: 756.3162583518931,
            angle: 0,
            scaleX: -0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnts_Cld1",
            x: 14.900259692805605, y: 17.643652561247215,
            angle: 0,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        }
    ]
}